const defaultResult = { classifieds: [], topPositionId: undefined };
export const getEffectIdsBySearchServiceModel = async ({ bffUri, searchServiceModel, suggestions, endpoint, }) => {
    if (!endpoint) {
        return defaultResult;
    }
    const effects = [
        {
            effect: 'Top_Position',
            size: 1,
        },
    ];
    if (suggestions > 0) {
        effects.push({
            effect: 'Suggestion',
            size: suggestions,
        });
    }
    const response = await fetch([bffUri, endpoint].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            criteria: searchServiceModel,
            effects,
        }),
        signal: AbortSignal.timeout(5000),
    });
    if (response.ok) {
        const reponse = await response.json();
        const suggestionEffect = reponse.effects.find((effect) => effect.effectType === 'Suggestion');
        const classifieds = suggestionEffect?.classifieds ?? [];
        const topPosition = reponse.effects.find((effect) => effect.effectType === 'Top_Position');
        return {
            classifieds: classifieds.map(({ id }) => id),
            topPositionId: topPosition && topPosition?.classifieds ? topPosition.classifieds[0]?.id : undefined,
        };
    }
    return defaultResult;
};
